import React, { Component } from 'react'
import { connect } from 'react-redux'
import { settingFileCategoryService } from '../../../../services/setting'
import { setRefreshFileCategory } from '../../../../states/actions/setting/file'
import { authService } from '../../../../services'

// UI
import { Button, Page, Pager, Panel, SideModal, List } from '../../../../components'
import Form from 'antd/lib/form'
import Switch from 'antd/lib/switch'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import Skeleton from 'antd/lib/skeleton'
import Popconfirm from 'antd/lib/popconfirm'
import message from 'antd/lib/message'

import './styles.css'
import notify from '../../../../components/Notification'

const pageSize = 20
const { Item: FormItem } = Form

const settingTitle = 'Category'
const settingType = 'category'

export class SettingFileCategory extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentPage: 1,
      filter: {},
      list: [],
      modal: {
        item: { link: {} },
        show: false
      },
      modalShow: false,
      searchText: '',
      selectedItem: { _id: null },
      sort: {},
      total: 0
    }
  }

  componentDidMount () {
    const { currentPage } = this.state
    this.fetchSettings({ currentPage })
  }

  fetchSettings = async ({ loading = false, currentPage = 1, filter = {}, sort = {}, searchText }) => {
    try {
      const { classification } = this.props
      this.setState({ currentPage, loading: true })

      filter.is_delete = { condition: '=', value: false }
      filter.classification = { condition: '=', value: classification }

      const settings = await settingFileCategoryService.listByPage(currentPage, pageSize, filter)

      this.setState({ list: settings.list, loading: false, total: settings.total })
    } catch (e) {
      notify.error('Unable to load successfully', 'Unable to load settings successfully. Please try again later.')
    }
  }

  hideModal = () => {
    const { form, onComplete } = this.props
    const { modal } = this.state
    const { resetFields } = form
    resetFields()
    modal.item = { link: {} }
    modal.show = false
    this.setState({ modal, selectedItem: {} })
    onComplete()
  }

  showModal = () => {
    const { modal } = this.state
    modal.show = true
    this.setState({ modal })
  }

  handleSave = () => {
    const { form, classification } = this.props
    const { validateFields } = form
    const { selectedItem, currentPage } = this.state

    validateFields(async (errors, values) => {
      if (!errors) {
        const { id } = selectedItem
        const { modal } = this.state
        const { item } = modal
        // values.type = settingType
        // values.value = values.name.toLowerCase()

        this.setState({ loadingForm: true })

        try {
          let response

          if (id) {
            response = await settingFileCategoryService.save(id, values)
          } else {
            values.classification = classification
            values.code = typeof values.name === 'string' ? values.name.toLowerCase() : values.name
            response = await settingFileCategoryService.add(values)
          }

          this.setState({ loadingForm: false })

          if (response.id) {
            const { id } = response
            modal.item = { ...item, ...values, id }

            this.setState({ modal })
            notify.success('Saved successfully', `${settingTitle} saved successfully.`)
            this.props.setRefreshFileCategory(true)
            this.fetchSettings({ currentPage: currentPage })
            this.hideModal()
          } else {
            notify.error('Unable to save successfully', `Unable to save ${settingType} successfully. Please try again later.`)
          }
        } catch (e) {
          notify.error('Unable to save successfully', `Unable to save ${settingType} successfully. Please try again later.`)
          this.setState({ loadingForm: false })
        }
      }
    })
  }

  handleEdit (id, name, description, active, is_editable) {
    this.setState({ selectedItem: { id, name, description, active, is_editable } })
    this.showModal()
  }

  // async handleDelete (id) {
  //   try {
  //     const res = await settingFileCategoryService.remove(id)

  //     if (res) {
  //       message.success('Deleted successfully', `${settingType} deleted successfully`)
  //       this.props.setRefreshFileCategory(true)
  //       this.fetchSettings({ currentPage: 1 })
  //     }
  //   } catch (e) {
  //     notify.error('Unable to delete', `Make sure all linked sub-categories has been deleted`)
  //   }
  // }

  async handleDelete (id) {
    try {
      const res = await settingFileCategoryService.delete(id)

      if (res) {
        message.success('Deleted successfully', `${settingType} deleted successfully`)
        this.props.setRefreshFileCategory(true)
        this.fetchSettings({ currentPage: 1 })
      }
    } catch (e) {
      notify.error('Unable to delete', `Make sure all linked sub-categories has been deleted`)
    }
  }

  hasAccess (accessLevel) {
    return authService.hasAccess(accessLevel)
  }

  render () {
    const { currentPage, list, loading, loadingForm, modal, selectedItem, total } = this.state
    const { form } = this.props
    const { getFieldDecorator } = form

    const columns = [
      {
        title: 'Name',
        width: 6,
        key: 'name'
      },
      {
        title: 'Description',
        width: 10,
        key: 'description'
      },
      {
        title: 'Enable',
        width: 6,
        render: ({ active }) => <div style={{ fontSize: '11pt' }}>{ active ? <Icon type='check-circle' theme='filled' /> : null }</div>
      },
      {
        title: '',
        width: 1,
        render: ({ id, name, description, active, is_editable }) => this.hasAccess('updateFileCategory') ? <div style={{ cursor: 'pointer' }} onClick={() => this.handleEdit(id, name, description, active, is_editable)}><Icon type='form' /></div> : null
      },
      {
        title: '',
        width: 1,
        render: ({ id, is_editable }) => this.hasAccess('deleteFileCategory') && is_editable ? <Popconfirm
          title='Confirm to delete this?'
          onConfirm={(e) => this.handleDelete(id)}
          okText='Yes'
          cancelText='No'
        ><Icon type='delete' />
        </Popconfirm> : null
      }
    ]

    return (
      <div>
        <div className='setting-list'>
          <Skeleton loading={loading} active>
            <List cols={columns} rows={list} />

            <Pager
              size={pageSize}
              total={total}
              totalText={`Total ${total} categories`}
              current={currentPage}
              onChange={this.changePage}
              style={{ marginTop: '15px' }}
            />
          </Skeleton>
        </div>

        <SideModal
          title={settingTitle}
          showModal={modal.show || this.props.onAdd}
          onClose={this.hideModal}
          buttons={[
            <Button key='0' onClick={this.handleSave} feedback={loadingForm}>Save</Button>
          ]}
        >
          <Form layout='vertical'>
            <FormItem label='Name'>
              {getFieldDecorator('name', {
                initialValue: selectedItem.name,
                rules: [
                  { min: 2, message: 'Name must be between 2 and 128 characters' },
                  { max: 128, message: 'Name must be between 2 and 128 characters' },
                  { required: true, message: 'Please enter name' },
                  { whitespace: true, message: 'Please enter name' }
                ]
              })(
                <Input disabled={selectedItem.is_editable === false} />
              )}
            </FormItem>
            <FormItem label='Description'>
              {getFieldDecorator('description', {
                initialValue: selectedItem.description,
                rules: [
                  { min: 2, message: 'Description must be between 2 and 128 characters' },
                  { max: 128, message: 'Description must be between 2 and 128 characters' },
                  { required: true, message: 'Please enter description' },
                  { whitespace: true, message: 'Please enter description' }
                ]
              })(
                <Input />
              )}
            </FormItem>
            <FormItem label=''>
              {getFieldDecorator('active', {
                initialValue: typeof selectedItem.active === 'boolean' ? selectedItem.active : true,
                valuePropName: 'checked'
              })(
                <Switch
                  disabled={selectedItem.is_editable === false}
                  checkedChildren='Enable'
                  unCheckedChildren='Disable'
                />
              )}
            </FormItem>
          </Form>

        </SideModal>
      </div>
    )
  }

  changePage = (currentPage) => {
    const { filter, searchText, sort } = this.state
    this.fetchSettings({ loading: true, currentPage, filter, sort, searchText })
  }
}

const mapDispatchToProps = {
  setRefreshFileCategory
}

const mapStateToProps = (state) => {
  return state
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(SettingFileCategory))
